import { FilteredResponseQueryOptions, QueryParams } from '@sanity/client';

import { sanityClient } from './index';

export type PerformSanityQueryProps = {
  groqQueryString: string;
  params?: QueryParams;
  options?: FilteredResponseQueryOptions;
};

export const performSanityQuery = async <T = any>({
  groqQueryString,
  params = {},
  options,
}: PerformSanityQueryProps): Promise<T> => {
  try {
    return await sanityClient.fetch<T>(groqQueryString, params, options);
  } catch (error: any) {
    throw new Error('Failed to perform Sanity Query', { cause: error });
  }
};
